import {HOST_API} from 'src/config-global';

const COMMENT_VOTE_API_URI = '/api/comment/vote';

export async function voteComment({commentId, type}) {
  const response = await fetch(`${HOST_API}${COMMENT_VOTE_API_URI}`, {
    method: 'PUT',
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
    },
    body: JSON.stringify({commentId, type})
  });

  if (!response.ok) {
    let message = `${response.status}:${response.statusText}`;
    if (response.status < 500) {
      const responseData = await response.json();
      message = responseData.error;
    }

    throw new Error(message);
  }

  return response.json();
}

